export default __webpack_public_path__ + "static/media/defendant-prosecutor.4284cdd5.jpg";